module.exports = __webpack_public_path__ + "static/media/3-01.36256046.png";